let isMapMoving = false
let pendingFetches = []

export const setMapMoving = (moving) => {
  isMapMoving = moving
  if (!moving) {
    // drain the queue when map stops
    pendingFetches.forEach(resolve => resolve())
    pendingFetches = []
  }
}

export const waitForMapIdle = () => {
  if (!isMapMoving) return Promise.resolve()
  return new Promise(resolve => pendingFetches.push(resolve))
}

//export const getSignal = true

/*

let isMapMoving = false
let pendingFetches = []
let currentController = new AbortController()

export const setMapMoving = (moving) => {
  isMapMoving = moving
  if (moving) {
    // abort any tiles currently being fetched
    currentController.abort()
    currentController = new AbortController()
  } else {
    pendingFetches.forEach(resolve => resolve())
    pendingFetches = []
  }
}

export const getSignal = true//() => currentController.signal

export const waitForMapIdle = () => {
  if (!isMapMoving) return Promise.resolve()
  return new Promise(resolve => pendingFetches.push(resolve))
}*/
